exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui-popup{display:none;position:absolute;font-family:Helvetica,arial,sans-serif}.ui-popup:focus{outline:0}.ui-popup-show{display:block}.ui-popup-modal:before{content:\"\";position:fixed;left:0;right:0;top:0;bottom:0;background:#000;opacity:.7;transform:scale(3);animation:ui-popup-opacity .15s 1 linear}.ui-popup-modal>*{position:relative}@keyframes ui-popup-opacity{0%{opacity:0}to{opacity:.7}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./src/css/ui-popup.css
// module id = 1
// module chunks = 0